// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC2EKw1hVqBXLf5kdUVKZetZRxxiKoY2Go",
  authDomain: "storbuddyauthentication.firebaseapp.com",
  projectId: "storbuddyauthentication",
  storageBucket: "storbuddyauthentication.firebasestorage.app",
  messagingSenderId: "918425743541",
  appId: "1:918425743541:web:cdb7ce0accd15c67d80efc",
  measurementId: "G-S1YVXCDHD4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
const provider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope('email');
facebookProvider.addScope('public_profile');
const analytics = getAnalytics(app);

export { auth, provider, facebookProvider, analytics };
